import { createContext, useContext } from 'react';

import type { S12nSessionDatesQuery_OnDemandCourseSessionsV1Resource_multiGet_elements as S12nSession } from 'bundles/enterprise-legacy-learner-home/components/single-program/__generated__/S12nSessionDatesQuery';

export type EnterpriseSpecializationSessionsContextType = {
  s12nSessionsLoading: boolean;
  s12nSessions?: S12nSession[];
};

const EnterpriseSpecializationSessionsContext = createContext<EnterpriseSpecializationSessionsContextType>({
  s12nSessionsLoading: false,
  s12nSessions: [],
});

export const useSpecializationSessions = () => {
  const context = useContext(EnterpriseSpecializationSessionsContext);

  return context;
};

export default EnterpriseSpecializationSessionsContext;
